import { availableDateFieldsType } from "@/propTypes";
import { Form, Input, Select } from "antd";
import { useIntl } from "react-intl";

import { FormFieldContainer } from "./styled";

export const DateEditFormField = ({ availableDateFields }) => {
  const intl = useIntl();
  const options = [
    {
      label: "",
      value: "",
    },
    {
      label: intl.formatMessage({
        id: "newFormField.createdDate",
        defaultMessage: "Created Date",
      }),
      value: "CreatedAt",
    },
    {
      label: intl.formatMessage({
        id: "newFormField.currentDate",
        defaultMessage: "Current Date",
      }),
      value: "CurrentDate",
    },
  ].concat(availableDateFields);
  return (
    <FormFieldContainer>
      <Form.Item
        name={["property", "label", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.fieldLabel" })}
        rules={[
          {
            required: true,
            message: intl.formatMessage({
              id: "newFormField.fieldLabelRequired",
            }),
          },
        ]}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "placeholder", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.placeholder" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "requiredValidationText", "fallback"]}
        label={intl.formatMessage({ id: "newFormField.validationErrorText" })}
      >
        <Input className="viper-form-element-max-width" />
      </Form.Item>
      <Form.Item
        name={["property", "startDateValidationField"]}
        label={intl.formatMessage({
          id: "newFormField.startDateValidationField",
        })}
      >
        <Select style={{ maxWidth: 500 }} options={options}></Select>
      </Form.Item>
      <Form.Item
        name={["property", "endDateValidationField"]}
        label={intl.formatMessage({
          id: "newFormField.endDateValidationField",
        })}
      >
        <Select style={{ maxWidth: 500 }} options={options}></Select>
      </Form.Item>
    </FormFieldContainer>
  );
};

DateEditFormField.propTypes = {
  availableDateFields: availableDateFieldsType,
};
